import React from "react";
import PropTypes from "prop-types";

/* Components */
import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@material-ui/core";

/* Icons */
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

/* Style */
import useStyles from "./PaymentRequiredModal.styles";

const PAYMENT_REQUIRED_MESSAGE =
  "Payment has not been collected for this ticket. Please direct the guest to the cashier before releasing the vehicle.";


const PaymentRequiredModal = ({ ticketNumber, onGoToPayment, onCancel }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={!!ticketNumber}
      onClose={onCancel}
      BackdropProps={{ classes: { root: classes.backdrop } }}
      PaperProps={{ className: classes.paper }}
      data-testid="payment-required-modal"
      className="payment-required-modal"
    >
      <DialogTitle disableTypography className={classes.header}>
        <Typography variant="h6" className={classes.title}>
          Payment Required
        </Typography>
        <Chip
          size="small"
          icon={<AttachMoneyIcon className={classes.unpaidChipIcon} />}
          label="Unpaid"
          className={classes.unpaidChip}
          data-testid="unpaid-badge"
        />
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" data-testid="ticket-number">
          Ticket #{ticketNumber}
        </Typography>
        <DialogContentText className={classes.message}>
          {PAYMENT_REQUIRED_MESSAGE}
        </DialogContentText>
        <div className={classes.actions}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={onGoToPayment}
            data-testid="go-to-payment"
            className="goToPaymentBtn"
          >
            Go to payment screen
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={onCancel}
            data-testid="cancel-payment-required"
            className="cancelBtn"
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

PaymentRequiredModal.defaultProps = {
  ticketNumber: "",
  onGoToPayment: () => {},
  onCancel: () => {},
};

PaymentRequiredModal.propTypes = {
  ticketNumber: PropTypes.string,
  onGoToPayment: PropTypes.func,
  onCancel: PropTypes.func,
};

export default PaymentRequiredModal;
